const CollapseMixin = {
    data() {
        return {
            computedHeight: 0
        };
    },

    computed: {
        computedStyle() {
            if (this.isActive) {
                return {
                    height: this.computedHeight,
                    opacity: 1
                };
            }

            return {};
        }
    },
    mounted() {
        this.getHeight();
        // next tick
        this.$nextTick(() => {
            window.addEventListener('resize', this.getHeight);
            this.getHeight();
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.getHeight);
    },
    methods: {
        getHeight() {
            const content = this.$el.querySelector('.collapse-item');
            if (content != null) {
                content.style.height = 'auto';
                content.style.position = 'absolute';
                content.style.visibility = 'hidden';

                this.computedHeight = getComputedStyle(content).height;

                if (!this.isActive) {
                    content.style.height = 0;
                } else {
                    content.style.height = this.computedHeight;
                }

                content.style.position = 'static';
                content.style.visibility = 'visible';
            }
        }
    }
};

export default CollapseMixin;
